/** "cards" are the things we can't scale to fit i.e journals, tiers, etc */ export const CARD_WIDTH = 350;
export const CARD_HEIGHT = 313;
/** Comments have smaller sizes */ export const SMALL_MEDIA_WIDTH = 212;
export const SMALL_MEDIA_HEIGHT = 190;

//# sourceMappingURL=constants.js.map